var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"musicwowDetails"},[_c('Headers'),_c('div',{staticClass:"musicwowDetails-center"},[_c('div',{staticClass:"center-body"},[_c('div',{staticClass:"body-title"},[_c('p',[_vm._v(_vm._s(_vm.listData.title))])]),_c('div',{staticClass:"items-image",domProps:{"innerHTML":_vm._s(_vm.listData.content)}})])]),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }